import { decodeJwt } from 'jose';
import type { DecodedJwt } from '@/features/auth/types';

export function decodeToken(token: string | null): DecodedJwt | null {
  if (!token) return null;
  try {
    return decodeJwt(token) as DecodedJwt;
  } catch {
    return null;
  }
}

export function isExpired(token: string | null, skewSeconds = 0): boolean {
  const d = decodeToken(token);
  if (!d?.exp) return true;
  return d.exp * 1000 < Date.now() + skewSeconds * 1000;
}

export function msUntilExpiry(token: string | null): number {
  const d = decodeToken(token);
  if (!d?.exp) return 0;
  return Math.max(0, d.exp * 1000 - Date.now());
}
